// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uCAPk","textarea":"styles_textarea__1Fvk8"};